import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  const images = props.gallery || [props.imgPath];

  return (
    <Card className="project-card-view">
      <div className="project-gallery">
        {images.map((image, index) => (
          <Card.Img
            key={image}
            variant="top"
            src={image}
            alt={`${props.title} portfolio visual ${index + 1}`}
            className={index === 0 ? "project-gallery-main" : "project-gallery-thumb"}
          />
        ))}
      </div>
      <Card.Body>
        <div className="project-meta">{props.role}</div>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

        {props.skills && (
          <div className="project-skill-list">
            {props.skills.map((skill) => (
              <span key={skill}>{skill}</span>
            ))}
          </div>
        )}

        {props.impact && <p className="project-impact">{props.impact}</p>}

        {props.ghLink && (
          <Button variant="primary" href={props.ghLink} target="_blank">
            <BsGithub /> &nbsp;
            {props.isBlog ? "Blog" : "GitHub"}
          </Button>
        )}

        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
